import { UseControllerProps } from 'react-hook-form';
import { InputAdornment, MenuItem, TextField, Tooltip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { validationTranslator } from '../../../helpers';
import { LightTooltip } from '../../LightTooltip';
import { useTranslation } from 'react-i18next';

export interface InputProps {
  register: any;
  errors: any
  name: any;
  defaultValue?: any;
  rules?: UseControllerProps['rules'];
  label: string;
  select?: boolean;
  options?: { value: string; label: string }[];
  tooltip?: {
    title: string;
    placement: "top" | "right" | "bottom" | "left" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end" | undefined;
  },
}

export const Input: React.FC<InputProps> = ({
  register,
  errors,
  name,
  rules,
  label,
  select,
  options,
  tooltip,
  defaultValue
}) => {
  const { t } = useTranslation();
  const { ref, ...inputProps } = register(name, rules);

  return (
    <Tooltip arrow title={tooltip !== undefined ? tooltip.title : ''} placement={tooltip !== undefined ? tooltip.placement : undefined}>
    <TextField
        fullWidth
        error={!!errors[name]}
        label={label}
        inputRef={ref}
        name={name}
        select={select}
        defaultValue={defaultValue}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
            {(!!errors[name]) && (
                <LightTooltip
                PopperProps={{ popperOptions: { placement: 'top' } }}
                title={
                    <Typography color="error">
                    {t(`errors.${!!errors[name]?.message ? errors[name]?.message! : validationTranslator(errors[name]?.type as any)}`)}
                    </Typography>
                }
                >
                <ErrorOutlineIcon color="error" />
                </LightTooltip>
            )}
            </InputAdornment>
          )
        }}
        {...inputProps}
    >
        {options &&
        select &&
        options.map(o => (
            <MenuItem key={o.value + o.label} value={o.value}>
            {o.label}
            </MenuItem>
        ))}
    </TextField>
    </Tooltip>
  );
}
